export class GcpVmInstanceRestoreTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "machineType",
            "baseName": "machineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkName",
            "baseName": "networkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkHostProject",
            "baseName": "networkHostProject",
            "type": "string",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<RestoreGcpInstanceDiskInput>",
            "format": ""
        },
        {
            "name": "internalIp",
            "baseName": "internalIp",
            "type": "string",
            "format": ""
        },
        {
            "name": "startInstanceAfterRestore",
            "baseName": "startInstanceAfterRestore",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmInstanceRestoreTarget.attributeTypeMap;
    }
    constructor() {
    }
}
